// components/NowCasting.js

import React, { useEffect, useState } from "react";
import CastingCategoriesTabs from "./CastingCategoriesTabs";
import { parseLocationCodes } from "../../utils/parseLocationCodes";
import { ENDPOINTS } from "../../api/endpoints";
import api from "../../api/api";

const NowCasting = () => {
  const [castingData, setCastingData] = useState([]);
  const [activeFilter, setActiveFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [locationsMap, setLocationsMap] = useState({});
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
      const res = await api.get(ENDPOINTS.getLocations());
      const data = res.data;
        const mappedLocations = {};

        data.data.forEach((item) => {
          mappedLocations[item.locationCode] =
            item.locationCity || item.locationState;
        });

        setLocationsMap(mappedLocations);
      } catch (err) {
        console.error("LOCATION API ERROR:", err);
      }
    };

    fetchLocations();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
      const res = await api.get(ENDPOINTS.getJobCategories());

const data = res.data;

        const active = data.data.filter((c) => c.activeFlag);

        setCategories(active);
      } catch (err) {
        console.error("CATEGORY API ERROR:", err);
      }
    };

    fetchCategories();
  }, []);

  const fetchCastingCalls = async (filter = null) => {
    try {
      setLoading(true);

      const payload = {
        Locations: [],
        Ethnicities: [],
        Unions: [],
        JobCategories: filter ? [filter] : [],
        RoleTypes: [],
        PayLevels: [],
        Sex: [],
        minAge: 0,
        maxAge: 100,
        page: 0,
        pageSize: 10,
        sortOrder: "DES",
        userId: 0,
        title: "",
        rushCall: false,
      };

    const res = await api.post(
  ENDPOINTS.getFilteredNotices(),
  payload
);

setCastingData(res.data?.data || []);
    } catch (err) {
      console.error("API ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCastingCalls(activeFilter);
  }, [activeFilter]);

  return (
    <section className="castings-section">
      <div className="ds-section-header ds-reveal">
        <div>
          <div className="ds-section-title">NOW CASTING</div>
        </div>

        <CastingCategoriesTabs
          categories={categories}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
        />
      </div>

      <div className="ds-casting-grid ds-reveal" id="dsCastingGrid">
        {loading ? (
          <p>Loading...</p>
        ) : castingData.length === 0 ? (
          <p>No casting calls found</p>
        ) : (
          castingData.map((item, index) => (
            <div
              key={index}
              className="ds-casting-card"
             onClick={() => {
  window.open(`/casting-call/${item.noticeId}`, "_blank");
}}
            >
              <div className="ds-casting-card-top">
                <span className="ds-casting-type">
                  {(item.category || "Casting").length > 20
                    ? `${(item.category || "Casting").slice(0, 20)}...`
                    : item.category || "Casting"}
                </span>

                {/* {item.rushCall && (
                  <span className="ds-casting-new">● New</span>
                )} */}
              </div>

              <h3>
                {(item.title || "").length > 70
                  ? `${item.title.slice(0, 70)}...`
                  : item.title}
              </h3>

              <div className="ds-casting-meta">
                <span>
                  📍{" "}
                  {(() => {
                    const locations = parseLocationCodes(item.locationCodes)
                      .map((code) => locationsMap[code] || code)
                      .join(", ");

                    return locations.length > 20
                      ? `${locations.slice(0, 20)}...`
                      : locations;
                  })()}
                </span>
                <span>👤 Casting {item.roleCount} Roles</span>
              </div>

              {
                <div className="ds-casting-card-footer">
                  <span className="unionStyle">
                    {(item.union || "").replace(/,/g, ", ")}
                  </span>
                </div>
              }
            </div>
          ))
        )}
      </div>

      <div className="ds-view-all ds-reveal">
        <a href="/casting-calls">VIEW ALL CASTING CALLS &rarr;</a>
      </div>
    </section>
  );
};

export default NowCasting;
